/**
 * Created by lihanying on 2017/7/20.
 */
import React from 'react'
import {
  Input,
  Table,
  Button,
  TimePicker,
  Checkbox,
  Row,
  Col,
  Tabs,
  Message,
} from 'antd'
import Popconfirm from '../../../components/Popconfirm/Popconfirm2'
import moment from 'moment'
import { fetchChangeList } from '../../../api/clubTable'

export default class extends React.Component {
  state = {
    showAdd: false, //新增
    showPrice: false, //修改
    start_time: null,
    end_time: null,
    hour_price: this.props.record.hour_price,
    page: 1,
    changeListData: {
      values: [],
      total: 0,
    },
  }

  componentDidMount() {
    this.getChangeList()
  }

  getChangeList = async () => {
    const tableId = this.props.tableDetailInfo.table.id
    const { data, status, detail } = await fetchChangeList({
      page: this.state.page,
      pageCount: 5,
      tableId,
    })
    if (status != 1) {
      Message.error(detail)
      return
    }
    this.setState({
      changeListData: data,
    })
  }

  onStartTime = (time, timeString) => {
    this.setState({ start_time: timeString })
  }

  onEndTime = (time, timeString) => {
    this.setState({ end_time: timeString })
  }

  //提交
  onSubmit = () => {
    if (
      !this.state.week_id ||
      this.state.week_id.length == 0 ||
      !this.state.time_price ||
      !this.state.start_time ||
      !this.state.end_time
    ) {
      Message.error('请填写完整信息')
      return
    }
    const data = {
      wday: this.state.week_id,
      sever_price: this.state.time_price,
      start_time: this.state.start_time,
      end_time: this.state.end_time,
      selectedId: [this.props.record.table_id], //数组
    }
    this.props.fetchAddTimeInterval(data)
    this.setState({ showAdd: false }, () => {
      this.setState({
        week_id: [],
        time_price: '',
        start_time: '',
        end_time: '',
      })
    })
  }

  //修改分时段价格
  onSubmitPrice = () => {
    const { intervalRow, new_price } = this.state
    this.props.fetchUpdateInterval(
      intervalRow.id,
      new_price,
      intervalRow.table_id
    )
    this.setState({ showPrice: false })
  }

  range = (start, end) => {
    const result = []
    for (let i = start; i < end; i++) {
      result.push(i)
    }
    return result
  }

  disabledHours = () => {
    const { start_time } = this.state
    let hours
    if (start_time) {
      let h = start_time.slice(0, 2) //'01:09:00'=>01
      let m = start_time.slice(3, 5)
      hours = this.range(0, 60)
      if (m < 59) {
        hours.splice(+h, 24 - +h)
      } else {
        hours.splice(+h + 1, 24 - +h)
      }
    } else {
      hours = this.range(0, 60)
      hours.splice(23, 0)
    }
    return hours
  }

  disabledMinutes = (hou) => {
    const { start_time } = this.state
    let hours
    if (start_time) {
      let h = start_time.slice(0, 2)
      let m = start_time.slice(3, 5)
      if (h < hou) {
        hours = this.range(0, 60)
        hours.splice(0, 60)
      } else {
        hours = this.range(0, 60)
        hours.splice(+m + 1, 60 - (+m - 1))
      }
    } else {
      hours = this.range(0, 60)
      hours.splice(59, 0)
    }
    return hours
  }

  onHintInfo = () => {
    const { hour_price } = this.state
    const { tableDetailInfo } = this.props
    let hint = ''
    if (sessionStorage.getItem('clz')) {
      if (sessionStorage.getItem('clz') != 1 && +hour_price <= 0) {
        hint = '桌台价格设置不能低于零元'
      }
    } else {
      if (tableDetailInfo.table.clz != 1 && +hour_price <= 0) {
        hint = '桌台价格设置不能低于零元'
      }
    }
    return hint
  }

  // 全选/取消全选星期
  selectAllWeek = () => {
    const weekDay = this.state.week_id == undefined ? [] : this.state.week_id
    if (weekDay.length != 7) {
      this.setState({
        week_id: [0, 1, 2, 3, 4, 5, 6],
      })
    }
    if (weekDay.length == 7) {
      this.setState({
        week_id: [],
      })
    }
  }

  render() {
    const { record, timePrice, tableDetailInfo } = this.props
    const weekDay = [
      { id: 0, day: '星期天' },
      { id: 1, day: '星期一' },
      { id: 2, day: '星期二' },
      { id: 3, day: '星期三' },
      { id: 4, day: '星期四' },
      { id: 5, day: '星期五' },
      { id: 6, day: '星期六' },
    ]
    const columns = [
      {
        title: '日期',
        dataIndex: 'weekDay',
        key: 'weekDay',
      },
      {
        title: '时间',
        dataIndex: 'time',
        key: 'time',
      },
      {
        title: '价格[元/小时]',
        dataIndex: 'price',
        key: 'price',
      },
      {
        title: '操作',
        dataIndex: 'edit',
        key: 'edit',
        render: (text, record, index) => {
          return (
            <div style={{ color: '#108EE9', cursor: 'default' }}>
              <Popconfirm
                title={`你确认要删除吗?`}
                okText="确认"
                cancelText="取消"
                onConfirm={() =>
                  this.props.fetchDeleteInterval([record.id], record.table_id)
                }
              >
                <span style={{ color: 'red' }}> 删除 |</span>
              </Popconfirm>
              <span
                onClick={() =>
                  this.setState({
                    showPrice: true,
                    showAdd: false,
                    intervalRow: record,
                  })
                }
              >
                {' '}
                修改分时段价格
              </span>
            </div>
          )
        },
      },
    ]

    const recordColumns = [
      {
        title: '时间',
        dataIndex: 'createTime',
        key: 'createTime',
        render: (text, record, index) => {
          return moment(text).format('YYYY-MM-DD HH:mm:ss')
        },
      },
      {
        title: '原价格(元)',
        dataIndex: 'hourPrice',
        key: 'hourPrice',
        render: (text, record, index) => {
          return (record.preTable.hourPrice / 100).toFixed(0)
        },
      },
      {
        title: '修改价格(元)',
        dataIndex: 'hourPrice2',
        key: 'hourPrice2',
        render: (text, record, index) => {
          return (record.afterTable.hourPrice / 100).toFixed(0)
        },
      },
      {
        title: '操作人',
        dataIndex: ['operator', 'name'],
        key: 'operator',
      },
    ]

    let dataList = []
    const data = timePrice.map((item, idx) => {
      let expend = item.length
      item.map((list) => {
        dataList = [].concat(dataList, {
          weekDay: weekDay[idx].day,
          time: list.start_time + '--' + list.end_time,
          id: list.id,
          price: list.price + '元/小时',
          table_id: list.table_id,
          wday: list.wday,
          expend: expend,
        })
        expend = 0
      })
    })

    return (
      <div>
        <div className="diamond-item">
          <span className="diamond-span">基本价格[元/小时]:</span>
          <Input
            size="large"
            defaultValue={tableDetailInfo.table.hourPrice}
            style={{ width: '40%', marginLeft: '2.5rem' }}
            placeholder="请输入单价"
            onChange={(e) => {
              sessionStorage.setItem('hour_price', e.target.value)
              this.setState({ hour_price: e.target.value })
            }}
          />
          <i className="hint_info">{this.onHintInfo()}</i>
        </div>

        <Tabs defaultActiveKey="1">
          <Tabs.TabPane tab="分时段价格" key="1">
            <Table
              rowKey="id"
              bordered
              size="small"
              columns={columns}
              dataSource={dataList}
              pagination={false}
            />

            <Button
              type="primary"
              style={{ marginTop: '1rem' }}
              onClick={() => this.setState({ showAdd: true, showPrice: false })}
            >
              新增分时段
            </Button>
            {this.state.showAdd && (
              <div>
                <div style={{ marginTop: '1rem' }}>
                  <p>
                    选择折扣日期:
                    <Button
                      type="primary"
                      size="small"
                      ghost
                      style={{ marginLeft: '20px' }}
                      onClick={this.selectAllWeek}
                    >
                      全选
                    </Button>
                  </p>
                  <Checkbox.Group
                    onChange={(value) => this.setState({ week_id: value })}
                    value={this.state.week_id}
                  >
                    <Row>
                      {weekDay.map((item, idx) => {
                        return (
                          <Col span={8} key={idx}>
                            <Checkbox value={item.id}>{item.day}</Checkbox>
                          </Col>
                        )
                      })}
                    </Row>
                  </Checkbox.Group>
                </div>
                <div style={{ marginTop: '1rem' }}>
                  <span>请输入价格:</span>
                  <Input
                    size="large"
                    style={{ width: '50%', marginLeft: '1.7rem' }}
                    placeholder="该打折时段单价"
                    onChange={(e) =>
                      this.setState({ time_price: e.target.value })
                    }
                  />
                </div>
                <div style={{ marginTop: '1rem' }}>
                  <span>选择开始时间:</span>
                  <TimePicker
                    onChange={this.onStartTime}
                    format="HH:mm"
                    defaultValue={moment('09:00', 'HH:mm')}
                    default
                    style={{ marginLeft: '.9rem' }}
                    value={
                      this.state.start_time
                        ? moment(`${this.state.start_time}`, 'HH:mm')
                        : null
                    }
                  />
                </div>
                <div style={{ marginTop: '1rem' }}>
                  <span>选择结束时间:</span>
                  <TimePicker
                    onChange={this.onEndTime}
                    format="HH:mm"
                    defaultValue={moment('12:00', 'HH:mm')}
                    style={{ marginLeft: '.9rem' }}
                    value={
                      this.state.end_time
                        ? moment(`${this.state.end_time}`, 'HH:mm')
                        : null
                    }
                    disabledHours={this.disabledHours}
                    disabledMinutes={this.disabledMinutes}
                  />
                </div>
                <Button
                  type="primary"
                  style={{ marginTop: '1rem' }}
                  onClick={() => this.onSubmit()}
                >
                  提交
                </Button>
              </div>
            )}
            {this.state.showPrice && (
              <div>
                <div style={{ marginTop: '1rem' }}>
                  <span>请输入新价格:</span>
                  <Input
                    size="large"
                    style={{ width: '50%', marginLeft: '1.7rem' }}
                    placeholder="该打折时段单价"
                    onChange={(e) =>
                      this.setState({ new_price: e.target.value })
                    }
                  />
                </div>
                <Button
                  type="primary"
                  style={{ marginTop: '1rem' }}
                  onClick={() => this.onSubmitPrice()}
                >
                  提交
                </Button>
              </div>
            )}
          </Tabs.TabPane>

          <Tabs.TabPane tab="修改价格记录" key="2">
            <Table
              rowKey="id"
              bordered
              size="small"
              columns={recordColumns}
              dataSource={this.state.changeListData.values}
              pagination={{
                pageSize: 5,
                total: this.state.changeListData.total,
                current: this.state.page,
                onChange: (page) => {
                  this.setState(
                    {
                      page: page,
                    },
                    () => {
                      this.getChangeList()
                    }
                  )
                },
              }}
            />
          </Tabs.TabPane>
        </Tabs>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubTable/component/timePrice.js